import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, from, map } from 'rxjs';
import { CORPORATE_ADMIN } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkRoles(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkRoles(route);
  }

  private checkRoles(route: ActivatedRouteSnapshot): Observable<boolean> {
    const allowedRoles = (route.data['roles'] ?? route.parent?.data['roles']) as string[];
    return from(this.authService.getUserRoles()).pipe(
      map((roles) => {
        if (roles && roles.length > 0 && Array.isArray(roles)) {
          const isAllowedRole = roles.some((r) => allowedRoles.includes(r));
          if (!isAllowedRole) {
            const fallbackRoute = roles.includes(CORPORATE_ADMIN) ? '/admintool' : '/dropoff';
            this.router.navigate([fallbackRoute]);
            return false;
          }
          return true;
        }
        this.router.navigate(['/dropoff']);
        return false;
      })
    );
  }
} 